document.addEventListener('DOMContentLoaded', function () {
  window.kk_swiper_customer_favs = new Swiper('.kk__customer-favs--swiper', {
    initialSlide: 0,
    loop: false,
    slidesPerView: 1,
    spaceBetween: 20,
    cache: false,

    // If we need pagination
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },

    breakpoints: {
      989: {
        slidesPerView: 1.25,
        spaceBetween: 20,
      },
      1100: {
        slidesPerView: 1.5,
        spaceBetween: 20,
      },
      1400: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
    },
  });
});

// document.addEventListener('shopify:section:load', () => {
//   window.kk_swiper_customer_favs.update();
// });